(function () {
	angular
		.module('trackeye')
		.directive('messageEventIcon', MessageEventIcon);

	function MessageEventIcon() {
		var exports = {};

		exports.restrict = 'E';
		exports.replace = true;
		exports.scope = {
			prevMessage: '=',
			message: '=',
			device: '='
		};

		exports.controller = 'MessageEventIconController as vm';
		exports.templateUrl = 'partials/device/SutMessages/MessageEventIcon/template.html';

		return exports;
	}
})();